<template>
  <div
    :class="
      props.type === 'investment-details'
        ? UIStore.is_dark_mode && !investmentStore.hasNoDistributions
          ? 'card card-dark'
          : !investmentStore.hasNoDistributions
            ? 'card card-light'
            : ''
        : ''
    "
    class="max-w-[1180px] w-full mx-auto"
  >
    <div :class="containerClasses" class="h-full rounded-2xl p-4 md:px-8 md:pb-8 md:pt-6">
      <div v-if="!UIStore.is_chart_loading" class="relative z-10">
        <slot name="chart-header" />
      </div>
      <div v-if="!UIStore.is_chart_loading" class="w-full">
        <LineChart
          :type="props.type"
          :class="investmentStore.hasNoDistributions ? '-bottom-8 -right-1 absolute' : ''"
        />
      </div>
      <div
        v-if="!UIStore.is_chart_loading"
        class="grid grid-cols-2 md:flex justify-between mt-6 space-y-2 md:space-y-0 md:space-x-4"
      >
        <div class="md:hidden items-center space-x-1">
          <p
            :class="
              props.type == 'investor-dashboard'
                ? 'text-[#bfbfbf] font-medium'
                : 'text-strongest font-semibold'
            "
            class="text-sm opacity-70"
          >
            {{ metrics[0]?.label }}
          </p>
          <h3
            :class="
              props.type == 'investor-dashboard'
                ? 'text-[#ffffff] font-medium'
                : 'text-strongest font-semibold'
            "
            class="text-xl md:text-2xl"
          >
            {{ metrics[0]?.value }}
          </h3>
        </div>

        <div class="flex items-center space-x-1 flex md:hidden">
          <Icon
            v-if="metrics[0]?.subtextIcon"
            :name="metrics[0]?.subtextIcon"
            :stroke-width="2"
            class="h-4 w-4 text-success"
          />
          <p
            :class="props.type == 'investor-dashboard' ? 'font-medium' : 'font-semibold'"
            class="text-sm text-success"
          >
            {{ metrics[0]?.subtext }}
          </p>
        </div>
        <!-- Awful workaround so that this works on mobile -->
        <div
          v-for="metric in metrics.slice(1)"
          :key="metric.label"
          class="align-left flex justify-between md:hidden block w-full ml-0 md:ml-2"
        >
          <div class="md:block flex items-center space-x-1">
            <div>
              <p
                :class="
                  props.type == 'investor-dashboard'
                    ? 'text-[#bfbfbf] font-medium'
                    : 'text-strongest font-semibold'
                "
                class="text-sm opacity-70"
              >
                {{ metric.label }}
              </p>
              <h3
                :class="
                  props.type == 'investor-dashboard'
                    ? 'text-[#ffffff] font-medium'
                    : 'text-strongest font-semibold'
                "
                class="text-xl md:text-2xl"
              >
                {{ metric.value }}
              </h3>
            </div>
          </div>
          <div class="flex items-center space-x-1 hidden md:flex">
            <Icon
              v-if="metric.subtextIcon"
              :name="metric.subtextIcon"
              :stroke-width="2"
              class="h-4 w-4 text-success"
            />
            <p
              :class="props.type == 'investor-dashboard' ? 'font-medium' : 'font-semibold'"
              class="text-sm text-success"
            >
              {{ metric.subtext }}
            </p>
          </div>
        </div>
        <div
          v-for="metric in metrics"
          :key="metric.label"
          class="align-left flex justify-between md:block hidden w-full ml-0 md:ml-2"
        >
          <div class="md:block flex items-center space-x-1">
            <div>
              <p
                :class="
                  props.type == 'investor-dashboard'
                    ? 'text-[#bfbfbf] font-medium'
                    : 'text-strongest font-semibold'
                "
                class="text-sm opacity-70"
              >
                {{ metric.label }}
              </p>
              <h3
                :class="
                  props.type == 'investor-dashboard'
                    ? 'text-[#ffffff] font-medium'
                    : 'text-strongest font-semibold'
                "
                class="text-xl md:text-2xl"
              >
                {{ metric.value }}
              </h3>
            </div>
          </div>
          <div class="flex items-center space-x-1 hidden md:flex">
            <Icon
              v-if="metric.subtextIcon"
              :name="metric.subtextIcon"
              :stroke-width="2"
              class="h-4 w-4 text-success"
            />
            <p
              :class="props.type == 'investor-dashboard' ? 'font-medium' : 'font-semibold'"
              class="text-sm text-success"
            >
              {{ metric.subtext }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="UIStore.is_chart_loading" class="flex justify-center items-center h-64">
        <LoadingSpinner :show="true" :hide-overlay="true" position="absolute" />
      </div>
    </div>
  </div>
</template>

<script setup>
// script for the investor dashboard
import LineChart from "./LineChart.vue";
import { Icon, LoadingSpinner } from "@/components";
import { useUIStore, useInvestmentStore } from "@/stores";
import { computed } from "vue";
const UIStore = useUIStore();
const investmentStore = useInvestmentStore();

const props = defineProps({
  metrics: { type: Array, default: () => [] },
  type: {
    type: String,
    default: "investment-details",
  },
});

const containerClasses = computed(() => {
  let classes = "";
  if (props.type === "investor-dashboard") {
    classes = "text-white bg-gradient-to-b from-primary-5 to-primary-7 relative overflow-hidden";
    if (investmentStore.hasNoDistributions) {
      classes += " h-[18rem]";
    } else {
      classes += " h-auto";
    }
  }

  if (props.type === "investment-earnings") {
    classes = "bg-bg-canvas relative overflow-hidden";
    if (investmentStore.hasNoDistributions) {
      classes += " h-[18rem]";
    } else {
      classes += " h-auto";
    }
  }

  if (props.type === "investment-details") {
    classes = "bg-container-bg relative overflow-hidden";
    if (investmentStore.hasNoDistributions) {
      classes += " md:h-[18.1rem] h-[15rem]";
    } else {
      classes += " h-auto";
    }
  }
  return classes;
});
</script>
<style scoped>
.card-dark {
  position: relative;
  border-radius: 24px;
  padding: 2px; /* thickness of border */

  background: linear-gradient(90deg, #ff9523, #f0c16c, #244057) border-box;
}

.card-light {
  position: relative;
  border-radius: 24px;
  padding: 2px; /* thickness of border */

  background: linear-gradient(90deg, #ff9523, #f0c16c, #f4ebda) border-box;
}

.card > * {
  /* inner card color */
  border-radius: 23px; /* radius - 1px */
}
</style>
